import { DepartmentResponsibleState } from './types';

export const state = (): DepartmentResponsibleState => initialState();

export const initialState = (): DepartmentResponsibleState => ({
  departmentResponsibles: {
    items: [],
    isLoading: false,
    total: 0,
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: [],
    },
  },
});
